export default __webpack_public_path__ + "static/media/Kosmos1266.6f2be66d.mp3";